import styled, { css } from 'styled-components';
import { cardCommonStyle, cardDefaultStyle } from './Card';

export const OptionsInputWrap = styled.div`
  min-height: 40px;
  display: grid;
  grid-template-columns: 140px 1fr auto;
  grid-gap: 12px;
  align-items: center;
`;

export const OptionLabel = styled.span`
  font-weight: 700;
  margin: 0 0 0 4px;
  position: relative;
  font-size: 14px;
  line-height: 1.4;
  word-break: keep-all;
`;

export const InputLabel = styled.div`
  font-weight: 700;
`;

export const PreviewBox = styled.div<{
  angle?: number;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;

  ${cardCommonStyle}

  h3 {
    text-align: center;
    margin-bottom: 12px;
  }
`;

export const PreviewBox2 = styled.div<{
  angle?: number;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  background-color: var(--cardBackgroundColor);

  ${cardDefaultStyle}
  border: var(--cardBorderWidth) var(--cardBorderType) var(--cardLineColor);

  h3 {
    text-align: center;
    margin-bottom: 12px;
  }
`;

export const PrevImgBox = styled.div`
  width: 100%;
  height: 120px;
  background-color: var(--cardBackgroundColor);
  backdrop-filter: blur(12px);
  border-radius: var(--cardBorderRadius);
  border: 1px solid var(--lineColor);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: var(--subTextColor);
`;

const SettingWrapMap = {
  column: css`
    display: grid;
    grid-template-columns: 6fr 1fr;
    grid-gap: 12px;
  `,
  row: css`
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 12px;
  `,
};

export const SettingContainer = styled.div<{
  wrap?: 'row' | 'column';
  startSec?: boolean;
}>`
  padding: 32px 0;
  font-family: var(--defaultFontFamily);
  position: relative;
  width: 100%;
  max-width: 960px;
  border-bottom: 1px solid var(--lineColor);
  text-align: left;
  ${({ wrap }) => (wrap ? SettingWrapMap[wrap] : SettingWrapMap.row)}
  padding: ${({ startSec }) => (startSec ? '0 0 32px 0' : '32px 0')};

  &:last-of-type {
    border-bottom: 0;
  }

  #tab_btn_wrap {
    margin-bottom: 32px;
  }

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const SetGrid = styled.section`
  display: grid;
  grid-template-columns: 1fr 3fr;
  grid-gap: 12px;
  align-items: center;

  label {
    word-break: keep-all;
  }
`;
export const GridSec = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
export const LabelDescription = styled.p`
  font-size: 13px;
  color: var(--subTextColor);
  word-break: keep-all;
  font-family: var(--defaultFontFamily);
  margin: 8px 0 0 0;
  line-height: 1.6;
`;

export const ButtonWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
`;

export const ImgButtonWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

export const SettingTitle = styled.h5`
  margin-bottom: 24px;
`;

/** 섹션 내 소분류 레이블 (h6 수준) */
export const SettingSubTitle = styled.h6`
  font-size: 13px;
  color: var(--subTextColor);
  margin: 20px 0 8px 0;
  font-weight: 600;
  letter-spacing: 0.02em;
`;

export const InfoSec = styled.div`
  padding: 12px;
  background-color: var(--cardBackgroundColor);
  border: 1px solid var(--lineColor);
  border-radius: var(--cardBorderRadius);

  p {
    font-size: 13px;
    line-height: 1.6;
  }
`;

export const Info = styled.p`
  border-radius: 6px;
  padding: 12px;
  background-color: var(--cardBackgroundColor);
  border: 1px solid var(--cardLineColor);
  font-size: 14px;
  color: var(--subTextColor);
  line-height: 1.6;
  margin: 8px 0;
`;

export const SemiInfo = styled.p` 
  font-size: 12px;
  line-height: 1.3;
  color: var(--subTextColor);
`;

export const SettingContents = styled.div`
  padding: 24px;
`;
export const SettingHeader = styled.div`
  flex-shrink: 0;

  padding: 24px 16px;
  border-bottom: 1px solid var(--lineColor);

  span {
    display: block;
    font-size: 13px;
    color: var(--subTextColor);
    word-break: keep-all;
    font-family: var(--defaultFontFamily);
    margin: 8px 0 0 0;
  }
`;

// 디자인 선택 카드 (BackButtonDesignSet / ButtonDesignSet / LoadingDesignSet 공통)
export const DesignCard = styled.button<{
  selected?: boolean;
  $padding?: string;
  $bg?: string;
  $gap?: string;
  $hoverLift?: boolean;
}>`
  padding: ${({ $padding }) => $padding || '32px 16px 16px'};
  background-color: ${({ $bg }) => $bg || 'transparent'};
  border: 2px solid
    ${({ selected }) => (selected ? 'var(--primaryColor)' : 'var(--lineColor)')};
  border-radius: var(--cardBorderRadius);
  cursor: var(--hoverCursorURL), pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ $gap }) => $gap || '12px'};

  &:hover {
    border-color: var(--primaryColor);
    ${({ $hoverLift }) => $hoverLift && 'transform: translateY(-2px);'}
  }

  ${({ selected }) =>
    selected &&
    `box-shadow: 0 4px 12px rgba(var(--primaryColorRGB), 0.2);`}
`;

export const ListBox = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  p {
    line-height: 1.4;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    height: 100%;
  }
`;

/** 카드형 섹션 그룹 (테두리 + 배경 + 라운드) */
export const SectionGroup = styled.section`
  width: 100%;
  margin-bottom: 24px;
  padding: 20px;
  border: 1px solid var(--lineColor);
  border-radius: 12px;
  background: var(--cardBackgroundColor);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SectionTitleText = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: var(--textColor);
`;

export const SectionDescription = styled.p`
  margin: 0;
  font-size: 13px;
  color: var(--subTextColor);
  line-height: 1.4;
`;

export const SectionBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
